const palettes = [
    {
        name: 'Sandstone',
        page: '#f7f3ec',
        section: '#fffaf3',
        sectionAlt: '#efe6da',
        card: '#ffffff',
        cardAlt: '#f8f1e7',
        text: '#1f2937',
        muted: '#5b6472',
        accent: '#d97745',
        accentSoft: '#fff1e8',
        border: '#e8ddcf',
        dark: '#111827',
        darkSoft: '#243042',
        glowA: 'rgba(217, 119, 69, 0.22)',
        glowB: 'rgba(251, 191, 36, 0.18)',
    },
    {
        name: 'Sage',
        page: '#f2f5ef',
        section: '#f8fbf5',
        sectionAlt: '#e4ecdf',
        card: '#ffffff',
        cardAlt: '#f2f7ef',
        text: '#173226',
        muted: '#4b6359',
        accent: '#2f855a',
        accentSoft: '#e7f6ec',
        border: '#d8e5da',
        dark: '#10251b',
        darkSoft: '#18382a',
        glowA: 'rgba(47, 133, 90, 0.20)',
        glowB: 'rgba(132, 204, 22, 0.16)',
    },
    {
        name: 'Marine',
        page: '#eef4f8',
        section: '#f7fafc',
        sectionAlt: '#dde9f1',
        card: '#ffffff',
        cardAlt: '#edf5fb',
        text: '#172554',
        muted: '#47607a',
        accent: '#2563eb',
        accentSoft: '#e5f0ff',
        border: '#d6e4ef',
        dark: '#0f172a',
        darkSoft: '#1e293b',
        glowA: 'rgba(37, 99, 235, 0.18)',
        glowB: 'rgba(14, 165, 233, 0.18)',
    },
    {
        name: 'Terracotta',
        page: '#f8f1ec',
        section: '#fff9f5',
        sectionAlt: '#efe0d7',
        card: '#ffffff',
        cardAlt: '#faeee7',
        text: '#3b2017',
        muted: '#73554a',
        accent: '#c65d3a',
        accentSoft: '#fdece6',
        border: '#ecd6cc',
        dark: '#2a160f',
        darkSoft: '#4a2418',
        glowA: 'rgba(198, 93, 58, 0.22)',
        glowB: 'rgba(244, 114, 182, 0.14)',
    },
    {
        name: 'Slate',
        page: '#f4f6f8',
        section: '#fafbfd',
        sectionAlt: '#e7ebf0',
        card: '#ffffff',
        cardAlt: '#f3f6f9',
        text: '#111827',
        muted: '#4b5563',
        accent: '#0f766e',
        accentSoft: '#e4fbf7',
        border: '#dde3ea',
        dark: '#0b1220',
        darkSoft: '#1f2937',
        glowA: 'rgba(15, 118, 110, 0.18)',
        glowB: 'rgba(59, 130, 246, 0.14)',
    },
    {
        name: 'Rose Quartz',
        page: '#fbf1f3',
        section: '#fff7f8',
        sectionAlt: '#f4dde2',
        card: '#ffffff',
        cardAlt: '#fbebee',
        text: '#3b1725',
        muted: '#72505c',
        accent: '#db2777',
        accentSoft: '#fde7f1',
        border: '#efd4dd',
        dark: '#2a1120',
        darkSoft: '#4b1732',
        glowA: 'rgba(219, 39, 119, 0.16)',
        glowB: 'rgba(251, 146, 60, 0.18)',
    },
    {
        name: 'Citrus',
        page: '#faf7ec',
        section: '#fffdf4',
        sectionAlt: '#f1ead1',
        card: '#ffffff',
        cardAlt: '#fbf7e8',
        text: '#33230f',
        muted: '#69563e',
        accent: '#ca8a04',
        accentSoft: '#fef3c7',
        border: '#eadfb5',
        dark: '#24190b',
        darkSoft: '#473519',
        glowA: 'rgba(202, 138, 4, 0.18)',
        glowB: 'rgba(245, 158, 11, 0.15)',
    },
    {
        name: 'Lavender Smoke',
        page: '#f4f1f8',
        section: '#faf8fd',
        sectionAlt: '#e5ddf0',
        card: '#ffffff',
        cardAlt: '#f3eefb',
        text: '#25163d',
        muted: '#63567b',
        accent: '#7c3aed',
        accentSoft: '#efe7ff',
        border: '#ddd2ef',
        dark: '#1f1234',
        darkSoft: '#31204d',
        glowA: 'rgba(124, 58, 237, 0.16)',
        glowB: 'rgba(99, 102, 241, 0.14)',
    },
    {
        name: 'Arctic',
        page: '#eef7f8',
        section: '#f8fcfc',
        sectionAlt: '#dcede9',
        card: '#ffffff',
        cardAlt: '#edf8f8',
        text: '#12323a',
        muted: '#4f6970',
        accent: '#0891b2',
        accentSoft: '#dff6fb',
        border: '#d3e7e8',
        dark: '#0f2027',
        darkSoft: '#17343e',
        glowA: 'rgba(8, 145, 178, 0.18)',
        glowB: 'rgba(20, 184, 166, 0.14)',
    },
    {
        name: 'Graphite',
        page: '#f3f4f6',
        section: '#f9fafb',
        sectionAlt: '#e5e7eb',
        card: '#ffffff',
        cardAlt: '#f3f4f6',
        text: '#111827',
        muted: '#4b5563',
        accent: '#ea580c',
        accentSoft: '#ffedd5',
        border: '#dde1e6',
        dark: '#030712',
        darkSoft: '#111827',
        glowA: 'rgba(234, 88, 12, 0.16)',
        glowB: 'rgba(107, 114, 128, 0.15)',
    },
    {
        name: 'Cobalt Studio',
        page: '#edf3ff',
        section: '#f8fbff',
        sectionAlt: '#dae6ff',
        card: '#ffffff',
        cardAlt: '#edf4ff',
        text: '#102347',
        muted: '#51688e',
        accent: '#1d4ed8',
        accentSoft: '#deebff',
        border: '#d4def3',
        dark: '#081225',
        darkSoft: '#13284d',
        glowA: 'rgba(29, 78, 216, 0.18)',
        glowB: 'rgba(96, 165, 250, 0.18)',
    },
    {
        name: 'Clay House',
        page: '#f6efe9',
        section: '#fffaf6',
        sectionAlt: '#ecdcd0',
        card: '#fffdfb',
        cardAlt: '#f7eee7',
        text: '#352016',
        muted: '#786152',
        accent: '#b45309',
        accentSoft: '#fce9d8',
        border: '#e8d8c8',
        dark: '#24140d',
        darkSoft: '#4a2718',
        glowA: 'rgba(180, 83, 9, 0.18)',
        glowB: 'rgba(217, 119, 6, 0.14)',
    },
    {
        name: 'Mint Grid',
        page: '#edf8f3',
        section: '#f7fcf9',
        sectionAlt: '#dbefe5',
        card: '#ffffff',
        cardAlt: '#eef9f2',
        text: '#123125',
        muted: '#4f6d61',
        accent: '#0f9f6e',
        accentSoft: '#dff8ed',
        border: '#d3e9dd',
        dark: '#0b2118',
        darkSoft: '#19392d',
        glowA: 'rgba(15, 159, 110, 0.18)',
        glowB: 'rgba(74, 222, 128, 0.16)',
    },
    {
        name: 'Nocturne',
        page: '#f2f3f7',
        section: '#fafbff',
        sectionAlt: '#e5e8f0',
        card: '#ffffff',
        cardAlt: '#f2f4f8',
        text: '#1b1d36',
        muted: '#5f6483',
        accent: '#7c3aed',
        accentSoft: '#efe7ff',
        border: '#dde1eb',
        dark: '#0c1022',
        darkSoft: '#1a2140',
        glowA: 'rgba(124, 58, 237, 0.18)',
        glowB: 'rgba(236, 72, 153, 0.12)',
    },
];

const layouts = [
    { id: 'balanced', heroMode: 'split', reverseHero: false, comparisonMode: 'table' },
    { id: 'editorial', heroMode: 'split', reverseHero: true, comparisonMode: 'cards' },
    { id: 'stacked', heroMode: 'stacked', reverseHero: false, comparisonMode: 'table' },
    { id: 'showcase', heroMode: 'stacked', reverseHero: false, comparisonMode: 'cards' },
    { id: 'minimal', heroMode: 'split', reverseHero: false, comparisonMode: 'table' },
    { id: 'magazine', heroMode: 'split', reverseHero: false, comparisonMode: 'cards' },
    { id: 'atlas', heroMode: 'split', reverseHero: false, comparisonMode: 'table' },
    { id: 'signal', heroMode: 'stacked', reverseHero: false, comparisonMode: 'cards' },
    { id: 'poster', heroMode: 'stacked', reverseHero: false, comparisonMode: 'cards' },
    { id: 'spotlight', heroMode: 'split', reverseHero: false, comparisonMode: 'cards' },
    { id: 'ledger', heroMode: 'split', reverseHero: true, comparisonMode: 'table' },
    { id: 'gallery', heroMode: 'stacked', reverseHero: false, comparisonMode: 'cards' },
];

const surfaces = [
    { id: 'soft', heroPanelTone: 'light', heroCardTone: 'light' },
    { id: 'contrast', heroPanelTone: 'dark', heroCardTone: 'dark' },
];

const headingFonts = [
    "'Lexend', 'Avenir Next', 'Inter', ui-sans-serif, system-ui, sans-serif",
    "'Lexend', 'Iowan Old Style', 'Palatino Linotype', 'Book Antiqua', serif",
    "'Lexend', 'Gill Sans', 'Trebuchet MS', ui-sans-serif, system-ui, sans-serif",
    "'Lexend', 'Georgia', 'Times New Roman', serif",
    "'Lexend', 'Optima', 'Segoe UI', ui-sans-serif, system-ui, sans-serif",
    "'Lexend', 'Baskerville', 'Times New Roman', serif",
];

const bodyFonts = [
    "'Source Sans 3', 'Helvetica Neue', 'Inter', ui-sans-serif, system-ui, sans-serif",
    "'Source Sans 3', 'Avenir Next', 'Inter', ui-sans-serif, system-ui, sans-serif",
    "'Source Sans 3', 'Segoe UI', 'Inter', ui-sans-serif, system-ui, sans-serif",
    "'Source Sans 3', 'Charter', 'Georgia', serif",
    "'Source Sans 3', 'Arial', ui-sans-serif, system-ui, sans-serif",
];

export const DESIGN_VARIANT_COUNT = layouts.length * surfaces.length * palettes.length;

const variantsByService = new Map();

const buildVariants = (service) => {
    let id = 1;
    const variants = [];

    for (const layout of layouts) {
        for (const surface of surfaces) {
            for (const palette of palettes) {
                const paletteIndex = palettes.findIndex((entry) => entry.name === palette.name);
                const layoutIndex = layouts.findIndex((entry) => entry.id === layout.id);
                const surfaceIndex = surfaces.findIndex((entry) => entry.id === surface.id);
                const radiusSeed = 20 + ((paletteIndex + layoutIndex + surfaceIndex) % 4) * 4;

                variants.push({
                    id,
                    family: `${layout.id}-${surface.id}`,
                    name: `${service.toUpperCase()} ${layout.id} ${palette.name}`,
                    layout: layout.id,
                    heroMode: layout.heroMode,
                    reverseHero: layout.reverseHero,
                    comparisonMode: layout.comparisonMode,
                    palette,
                    surface,
                    typography: {
                        heading: headingFonts[(paletteIndex + layoutIndex) % headingFonts.length],
                        body: bodyFonts[(paletteIndex + surfaceIndex) % bodyFonts.length],
                    },
                    radius: {
                        xl: `${radiusSeed + 8}px`,
                        lg: `${radiusSeed}px`,
                        md: `${Math.max(16, radiusSeed - 4)}px`,
                    },
                    shadow: {
                        card: surface.id === 'contrast'
                            ? '0 18px 45px rgba(15, 23, 42, 0.12)'
                            : '0 14px 32px rgba(15, 23, 42, 0.06)',
                        panel: surface.id === 'contrast'
                            ? '0 28px 80px rgba(15, 23, 42, 0.24)'
                            : '0 24px 64px rgba(15, 23, 42, 0.12)',
                    },
                });

                id += 1;
            }
        }
    }

    return variants;
};

export const getAllDesignVariants = (service = 'pv') => {
    if (!variantsByService.has(service)) {
        variantsByService.set(service, buildVariants(service));
    }

    return variantsByService.get(service);
};

// Fixed single design variant -- warm cream editorial palette
const fixedVariant = {
    palette: {
        name: 'Editorial',
        page: '#FAF8F4',
        section: '#FFFFFF',
        sectionAlt: '#FFFFFF',
        card: '#FFFFFF',
        cardAlt: '#FAF8F4',
        text: '#1A1A17',
        muted: '#6B6B66',
        accent: '#2E676B',
        accentSoft: 'rgba(31, 107, 58, 0.06)',
        border: '#E8E4DB',
        dark: '#1A1A17',
        darkSoft: '#2a2a27',
        glowA: 'rgba(31, 107, 58, 0)',
        glowB: 'rgba(31, 107, 58, 0)',
    },
    layout: { id: 'balanced', heroMode: 'split', reverseHero: false, comparisonMode: 'table' },
    surface: { id: 'soft', heroPanelTone: 'light', heroCardTone: 'light', mode: 'light' },
    typography: {
        heading: "var(--dv-font-heading)",
        body: "'Inter', ui-sans-serif, system-ui, sans-serif",
    },
    radius: { xl: '6px', lg: '4px', md: '4px' },
    shadow: {
        card: 'none',
        panel: 'none',
    },
};

export const getDesignVariant = (variantId = 1, service = 'pv') => {
    return fixedVariant;
};